export default __webpack_public_path__ + "static/media/Diana.f48fa28e.png";